@import 'core';

/**
 * @prop --ads-card-background-color: Background color
 * @prop --ads-card-background-color-hover: Hovered background color
 *
 * @prop --ads-card-border-color: Border color
 * @prop --ads-card-border-color-hover: Hovered border color
 * @prop --ads-card-border-radius: Border radius
 * @prop --ads-card-border-style: Border style
 * @prop --ads-card-border-width: Border width
 *
 * @prop --ads-card-box-shadow: Box shadow
 * @prop --ads-card-box-shadow-hover: Hovered box shadow
 *
 * @prop --ads-card-content-color: Text color
 * @prop --ads-card-image-background-color: Image background color
 * @prop --ads-card-image-min-height: Image min height
 * @prop --ads-card-label-color: Label color
 * @prop --ads-card-margin: Card margin
 * @prop --ads-card-padding: Card padding
 * @prop --ads-card-hover-shiftup-px: Hover shift up in pixels
 * @prop --ads-card-wrapper-overflow: Wrapper overflow
 */

:host([theme='default']) {
  @include ads-vars-component-card-default;
}

:host([theme='dark']) {
  @include ads-vars-component-card-dark;
}

:host {
  border-radius: var(--ads-card-border-radius, $ads-card-border-radius);
  display: flex;
  flex: 1 0 auto;
  font-family: var(--ads-font-family);
  height: 100%;
 

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  .c-card {
    align-items: stretch;
    background-color: var(--ads-card-background-color, $ads-card-background-color);
    border-color: var(--ads-card-border-color, $ads-card-border-color);
    border-radius: var(--ads-card-border-radius, $ads-card-border-radius);
    border-style: var(--ads-card-border-style, $ads-card-border-style);
    border-width: var(--ads-card-border-width, $ads-card-border-width);
    box-shadow: var(--ads-card-box-shadow, $ads-card-box-shadow);
    box-sizing: border-box;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    height: auto;
    justify-content: stretch;
    position: relative;
    text-decoration: none;
    transition: background-color, border-color, box-shadow, transform;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
    width: 100%;
    margin: var(--ads-card-margin, $ads-card-margin);
    padding: var(--ads-card-padding, $ads-card-padding);

    &:focus,
    &:hover {
      background-color: var(--ads-card-background-color-hover, $ads-card-background-color-hover);
      border-color: var(--ads-card-border-color-hover, $ads-card-border-color-hover);
      box-shadow: var(--ads-card-box-shadow-hover, $ads-card-box-shadow-hover);
      transform: translateY(calc(var(--ads-card-hover-shiftup-px, $ads-card-hover-shiftup-px) * -1));
    }

    &:active {
      transform: translateY(calc(var(--ads-card-hover-shiftup-px, $ads-card-hover-shiftup-px) * -1));
    }

    /* MODIFIERS */

    &.has-hover-effect:focus,
    &.has-hover-effect:hover {
      transform: var(--ads-card-transform-hover, $ads-card-transform-hover);
    }

    &.has-label {
      border-top-width: 0 !important;
      margin-top: 15px;
    }

    &.has-open-border {
      border-right-width: 0 !important;

      &::before {
        border-color: inherit;
        border-right-style: var(--ads-card-border-style, $ads-card-border-style);
        border-right-width: var(--ads-card-border-width, $ads-card-border-width);
        bottom: 70px;
        content: '';
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
      }
    }


    /* DESCENDANTS */

    &__label {
      border-color: inherit;
      border-style: none;
      border-width: inherit;
      height: 30px;
      position: absolute;
      top: -15px;
      width: 100%;

      > slot[name='label'] {
        border-color: inherit;
      }
    }

    &__wrapper {
      border-radius: var(--ads-card-border-radius, $ads-card-border-radius);
      display: flex;
      flex: 1 0 auto;
      flex-direction: column;
      overflow: var(--ads-card-wrapper-overflow, $ads-card-wrapper-overflow);
      z-index: 0;
    }

    &.is-horizontal .c-card__wrapper {

      @include media-query(sm-up) {
        flex-direction: row;
      }
    }

    &__image {
      align-items: center;
      display: flex;
      flex: 0 0 auto;
      justify-content: center;
      line-height: 0;
      overflow: hidden;
    }

    &__content {
      display: flex;
      flex: 1 0 auto;
    }

    &.is-horizontal .c-card__image,
    &.is-horizontal .c-card__content {

      @include media-query(sm-up) {
        width: 50%;
      }
    }
  }
}
